import { DropLocation, SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { P2GBox, P2GCheckBoxLegacy, P2GText } from '@parcel2go/core-ui';
import { useState } from 'react';

import Loading from '~/components/loading/Loading';
import useOnLoad from '~/routes/use-on-load';
import { useSmartSendApi } from '~/lib/api/smartsend/use-smartsend-api';
import { AppCard } from '~/components/card/app-card';
import { useDistance } from '@parcel2go/npm-p2g-app';

interface props {
  item: SmartSendItemApiModel;
  selected: number;
  onSelectLocation: (location: DropLocation) => void;
}

export default function ClosestPickUpShops({ item, onSelectLocation, selected }: props) {
  const { getDropLocations } = useSmartSendApi();
  const { toDistance } = useDistance();
  const [locations, setLocations] = useState<DropLocation[]>();

  useOnLoad(() => {
    const load = async () => {
      if (!item.State?.validation?.QuoteState?.Quote?.Service) {
        return;
      }

      const res = await getDropLocations(
        item.State.validation.QuoteState.Quote.Service.Provider,
        item.State.validation.QuoteState.Quote.Service.AccountId,
        item.State.validation.QuoteState.Quote.Service.PickUpProviderCode,
        item.Recipient.CountryIsoCode,
        item.Recipient.Postcode
      );
      if (res.success) {
        setLocations(res.result.DropLocations.filter((x) => x.AcceptsDelivery).slice(0, 5));
      }
    };
    load();
  });

  if (!locations) {
    return <Loading />;
  }

  return (
    <P2GBox sx={{ display: 'grid', gap: 1, py: 2 }}>
      {locations.map((l) => (
        <P2GBox key={l.Id}>
          <AppCard>
            <P2GBox p={1}>
              <P2GCheckBoxLegacy
                checked={l.Id === selected}
                id={`pickup-location-${l.Id}`}
                onChange={() => onSelectLocation(l)}
                label={
                  <P2GText variant="body2">
                    {l.Name}{' '}
                    <P2GText variant="caption">
                      <strong>({toDistance(l.Distance)})</strong>
                    </P2GText>
                  </P2GText>
                }
              />
            </P2GBox>
          </AppCard>
        </P2GBox>
      ))}
    </P2GBox>
  );
}
